"use strict";

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _BurguerMenu = _interopRequireDefault(require("./BurguerMenu"));

var _LogoAxon = _interopRequireDefault(require("./LogoAxon"));

var _wrapperSidebarContext = require("../wrapperSidebarContext");

var S = _interopRequireWildcard(require("./Header.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Header = () => {
  var {
    session,
    isInMobile
  } = (0, _react.useContext)(_wrapperSidebarContext.WrapperSidebarContext);
  return /*#__PURE__*/_react.default.createElement(S.Header, null, /*#__PURE__*/_react.default.createElement(_BurguerMenu.default, null), /*#__PURE__*/_react.default.createElement(_LogoAxon.default, null), !isInMobile && /*#__PURE__*/_react.default.createElement("img", {
    src: session.avatar,
    alt: "Avatar default de usuario",
    style: {
      width: '2rem',
      height: '2rem',
      objectFit: 'cover',
      borderRadius: '50%'
    }
  }));
};

var _default = Header;
exports.default = _default;